import moment from "moment";

// Validate start date so that it is not after today or after a selected end date
export function isValidStartDate(current, endDate) {
  const isTodayOrEarlier = current.isSameOrBefore(moment());
  if (endDate) {
    return current.isBefore(endDate) && isTodayOrEarlier;
  }

  return isTodayOrEarlier;
}

// Validate end date so that it is not after today or before a selected start date
export function isValidEndDate(current, startDate) {
  const isTodayOrEarlier = current.isSameOrBefore(moment());
  if (startDate) {
    return current.isAfter(startDate) && isTodayOrEarlier;
  }

  return isTodayOrEarlier;
}



// WEBPACK FOOTER //
// ./src/_helpers/dateValidation.js